import { render, staticRenderFns } from "./ApplyDetailTable.vue?vue&type=template&id=5b47d84e&scoped=true"
import script from "./ApplyDetailTable.vue?vue&type=script&lang=js"
export * from "./ApplyDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47d84e",
  null
  
)

export default component.exports